import React from "react";
import home from "../assets/rank10.png"
import StatsSection from "./HomePage1";
import { FaPhoneAlt } from "react-icons/fa";
import Homepage2 from "./HomePage2";
import CircleFeatures from "./circlerimages";
import AcademicPrograms from "./rankridgegrades";
import ImageCarousel from "./image_carousel";
import { nav } from "framer-motion/m";
import { useNavigate } from "react-router-dom";
import CommonImageSlider from "./comandata";
import { acadmicImages, homeImages, neetRankImages, studentsRanks } from "./data";
import FeatureCards from "./FeatureCards";
import WhyChooseRankridge from "./rankridge_why_choose";
import CourseGrid from "./coursegrid";
import RankridgeFAQNumbered from "./rankridge_admission_faq_react_tailwind_seo_ready";
import RankridgeFAQTease from "./newfag";
import SeoMeta from "./seometa/seometa";
import CommonImageSliderRanks from "./CommonsliderRanks";
import CourseEnquiry from "./newform";


const seoHome = {
  title: "Rankridge - Best IIT JEE & NEET Long Term | Junior College",
  description: "Hyderabad’s best junior college for IIT JEE Long Term, NEET Long Term, MPC & BiPC Intermediate programs. Expert faculty & proven top results.",
  keywords: "Rankridge Junior College Hyderabad, Best Junior Colleges in Hyderabad, Intermediate Colleges in Hyderabad, MPC Junior College Hyderabad, BiPC Junior College Hyderabad, IIT JEE Foundation Junior College Hyderabad, NEET Foundation Junior College Hyderabad, Best Intermediate Colleges for MPC, Best Intermediate Colleges for BiPC, Best MPC Residential Colleges in Hyderabad, Best BiPC Residential Colleges in Hyderabad, Junior College with Hostel Facility Hyderabad, Best Residential Junior Colleges in Hyderabad, Rankridge Junior College KPHB, Junior Colleges Near KPHB Hyderabad, Best Junior College Near Kukatpally, Junior Colleges Near Hitech City Hyderabad, Best Colleges for 11th and 12th in Hyderabad, Top Intermediate Colleges in Hyderabad, Junior Colleges with Sports Facilities Hyderabad, Colleges with Best Sports Infrastructure, IIT JEE Coaching Junior College Hyderabad, NEET Coaching Junior College Hyderabad, Top Junior Colleges for MPC and BiPC, Rankridge IIT JEE Foundation, Rankridge NEET Foundation, Best Junior College Admissions Hyderabad, Junior College Admissions Hyderabad",
  canonical_path: "https://www.rankridge.com/",
  og_description: "",
  og_image: "",
};


 function Homepage() {
const navigate=useNavigate()
 const closeMenu = () =>{
navigate("/form")
    window.scrollTo({top:0,behavior:"smooth"})
   } 

  return (
    <div>
 <h1 className="text-xl sm:text-4xl md:text-3xl xl:text-5xl font-bold leading-tight mt-1 text-center">
        Rankridge - Empowering  <span className="text-[black]"> & Creating India’s Top IITians & Doctors</span> <br />
        </h1>
     <section style={{marginTop:"-20px"}} className="bg-white  px-4 sm:px-1 md:px-2 xl:px-1 flex flex-col-reverse  items-center justify-between gap-1">
     
   

      <div className="w-full   text-center md:text-left space-y-5">
        

        <p className=" text-black sm:text-lg md:text-base xl:text-lg capitalize mt-3">
         Empowering Young Minds with a World-Class Learning platform and dynamic
 resources  to curiosity, creativity & academic excellence in IIT-JEE & NEET.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-center ">
         <a href="tel:+919959303873" className="flex items-center justify-center">
  <button className="flex font-roboto items-center justify-center gap-2 bg-[#20b2aa] text-black px-6 py-3 rounded-lg font-semibold hover:bg-gray-200 transition">
    <FaPhoneAlt />
    Call Now +91 99 59 271 353
  </button>
</a>

          <button onClick={closeMenu} className="bg-green-900 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-800 transition">
          ENQUIRE NOW
          </button>
         
        </div>

      </div>

      <div className="w-full  justify-center bg-[#20b2aa] pe-2 ps-2 mt-10 ">
{/* 
        <img src={home}alt="Student"
          className="w-full max-w-md sm:max-w-lg md:max-w-md lg:max-w-lg xl:max-w-xl h-auto object-contain rounded-xl"/>
     */}
    
{/* <CourseEnquiry /> */}
 <CommonImageSliderRanks images={studentsRanks}  />

        {/* <CommonImageSlider images={studentsRanks} /> */}

      {/* <ImageCarousel /> */}
      </div> 

    </section>
<section>
  <AcademicPrograms />
</section>

    <section>
      <FeatureCards />
      {/* <CircleFeatures /> */}
    </section>

      <section>
      <CourseGrid />
    
    </section>
    {/* <StatsSection /> */}
    <WhyChooseRankridge />

    <section>
      {/* <RankridgeFAQNumbered />  */}
      <RankridgeFAQTease />
      {/* <FaqAccordion /> */}
    </section>

    <SeoMeta seopages={seoHome} />
    </div>
  );
}
export default Homepage